module.exports = __webpack_public_path__ + "static/media/video-player.05c88ccf.svg";